import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import "./style.css";
import Axios from "../../../config";
import { toast } from "helpers/apiRequests";

const DeleteConnectorV2 = ({ openModal, handleClose, connector,removeConnector }) => {
  const [loading, setLoading] = useState(false);

  const deleteMySqlDB = async () => {
    try {
      setLoading(true);
      const payload = { credential_ids: [connector], };
      const url = `/delete-user-db`;
      await Axios.post(url, payload);
      setLoading(false);
      removeConnector();
      handleClose();
      toast.notify(`Connector deleted successfully`);
    } catch (error) {
      setLoading(false);
      handleClose();
      toast.notify(error.message, { type: "error" });
    }
  };

  return (
    <div>

      <Dialog
        open={openModal}
        onClose={handleClose}
        // hideBackdrop={true}
        disableBackdropClick={false}
        disableEscapeKeyDown={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="connector-modal"
      >
        <DialogContent>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography gutterBottom>
                You are about to delete your connection.
                <br />
                Would you like to proceed?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button id="button-cancel" disabled={loading} onClick={handleClose} color="primary">
              No
            </Button>
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              <Button
                id="button-save"
                onClick={deleteMySqlDB}
                color="primary"
                autoFocus
              >
                Yes
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DeleteConnectorV2;
